import { Link, LinkProps } from '@mui/material';

export default function ExternalLink({ children, ...props }: LinkProps) {
  return (
    <Link target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </Link>
  );
}
